export default "__VITE_ASSET__518f9534__"